import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const FolderIcon: FC<IconProps> = ({ size = 48}) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="#F3F3F5"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M30.6667 31.5C31.1269 31.5 31.5 31.1269 31.5 30.6667V23.1667H25.6667V24.8333H22.3333V23.1667H16.5V30.6667C16.5 31.1269 16.8731 31.5 17.3333 31.5H30.6667ZM27.3333 26.5V24.8333H29.8333V29.8333H18.1667V24.8333H20.6667V26.5H27.3333Z" fill="#717284"/>
    <path d="M30.6667 18.1667H17.3333V16.5H30.6667V18.1667Z" fill="#717284"/>
    <path d="M17.3333 21.5H30.6667V19.8333H17.3333V21.5Z" fill="#717284"/>
  </svg>

)

export default FolderIcon
